/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliParentStudentDto } from '../../models/amoxcalli-parent-student-dto';

export interface ApiParentStudentsMineGet$Plain$Params {
}

export function apiParentStudentsMineGet$Plain(http: HttpClient, rootUrl: string, params?: ApiParentStudentsMineGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliParentStudentDto>>> {
  const rb = new RequestBuilder(rootUrl, apiParentStudentsMineGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliParentStudentDto>>;
    })
  );
}

apiParentStudentsMineGet$Plain.PATH = '/api/parent-students/mine';
